import { Card } from "@prisma/ui";
import { useQuery } from "@tanstack/react-query";
import { Sparkles } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { PageHeader } from "../../components/PageHeader";
import { QueryState } from "../../components/QueryState";
import { RequestStatusChip } from "../../components/Status";
import { api, call } from "../../lib/api";
import type { components } from "../../lib/api-types";
import { formatRelative, secondsSince } from "../../lib/format";

type Row = components["schemas"]["KaryaSessionRowOut"];

/** Karya (plan v2 /karya): recent strategy sessions, each opening its project strategy. */
export function KaryaPage() {
  const { t, i18n } = useTranslation();
  const q = useQuery({ queryKey: ["karya", "sessions"], queryFn: () => call<Row[]>(api.GET("/app/v1/karya/sessions")) });
  return (
    <div className="space-y-6">
      <PageHeader titleKey="karya.page_title" subtitle={t("karya.page_subtitle")} />
      <QueryState query={q} emptyKey="karya.sessions_empty">
        {(rows) => (
          <Card className="divide-y divide-[var(--border-default)]">
            {rows.map((r) => (
              <Link key={r.display_id} to={`/projects/${r.display_id}/strategy`} className="flex items-center gap-4 px-5 py-4 hover:bg-elevated">
                <span aria-hidden="true" className="flex size-10 items-center justify-center rounded-full bg-[var(--accent-primary-soft)] text-violet"><Sparkles className="size-5" /></span>
                <div className="min-w-0 flex-1">
                  <div className="font-medium text-ink">{r.product_name} · {r.display_id}</div>
                  <div className="text-[13px] text-ink-2">{t(`requests.objective_${r.objective.toLowerCase()}`)}</div>
                </div>
                <RequestStatusChip status={r.status} />
                <span className="w-32 text-right text-[12px] text-ink-2">{r.last_session_at ? formatRelative(secondsSince(r.last_session_at), i18n.language) : ""}</span>
              </Link>
            ))}
          </Card>
        )}
      </QueryState>
    </div>
  );
}
